module.exports = __webpack_public_path__ + "static/media/analytics-studio.d65d8335.svg";